// 거래처 「사업장」(2026-10-15 게시판 sRX4v2c2 · CS 강유정) — 판정·표시 정본.
//   DB하이텍은 부천·상우 두 사업장이 한 거래처(`tenants/db`)로 묶여 있어 문의가 'DB하이텍' 으로만 보였다.
//   거래처를 쪼개지 않고(위젯 `?tenant=db` URL 계약) 고객이 접수 때 고른 `site` 를 이름 뒤에 붙인다.
// ⚠️ functions/src/tenantSite.ts 가 이 파일의 미러다(functions 는 shared 를 런타임 import 못 한다) —
//    한쪽만 고치지 말 것. `scripts/verify-tenant-site.cjs` 가 같은 입력으로 두 벌을 대조한다.

/** 사업장 이름 최대 길이(설정·티켓 공통). */
export const MAX_SITE_LEN = 30;

/** 사업장 이름 정리 — 앞뒤 공백 제거·안쪽 연속 공백 하나로·길이 자르기. */
function cleanSite(raw: unknown): string {
  if (typeof raw !== 'string') return '';
  return raw.replace(/\s+/g, ' ').trim().slice(0, MAX_SITE_LEN);
}

/**
 * 거래처 설정의 사업장 목록 정규화 — 문자열만·빈 값 제거·중복 제거(처음 순서 유지).
 * 배열이 아니면 [] (= 칸 없음).
 */
export function normalizeSites(raw: unknown): string[] {
  if (!Array.isArray(raw)) return [];
  const out: string[] = [];
  for (const v of raw) {
    const s = cleanSite(v);
    if (s && !out.includes(s)) out.push(s);
  }
  return out;
}

/** 콘솔 입력칸(쉼표 또는 줄바꿈 구분) → 사업장 목록. */
export function parseSitesInput(text: string): string[] {
  return normalizeSites(String(text ?? '').split(/[,\n]/));
}

/**
 * 접수로 들어온 사업장 값 판정(서버 관문과 같은 자).
 *   거래처에 사업장이 없으면 → '' (값이 와도 버린다 — 폼에 없는 칸이 함수 호출로만 채워지면 안 된다)
 *   목록 안의 값이면 → 그 값(목록의 표기 그대로)
 *   목록 밖·빈 값 → '' (🔴 거부하지 않는다 — 묵은 iframe 번들이 칸 없이 제출해도 접수는 살린다)
 */
export function pickSite(sites: unknown, raw: unknown): string {
  // 빈 목록·빈 값은 includes 가 알아서 '' 로 떨어뜨린다(normalizeSites 결과엔 빈 문자열이 없다).
  const list = normalizeSites(sites);
  const v = cleanSite(raw);
  return list.includes(v) ? v : '';
}

/** 티켓에 붙은 거래처 표시 이름 — site 가 있으면 'DB하이텍(부천)', 없으면 이름 그대로. */
export function tenantLabel(name: string, site?: string | null): string {
  const s = cleanSite(site ?? '');
  return s ? `${name}(${s})` : name;
}
